export default class Transform  {

  transformAudiosToFormData(input) {
    const files = [];
    let { items, roomId, userName, role, userId } = input;
    for(const item of items) {
      const { blob, fileName } = item;
      var file = new File([blob], this.getFileName(fileName,'mp3'), {
        type: 'audio/mp3'
      });
      files.push(file);
			console.log(item);
    }
    
    items = items.map((item) => {  
      delete item.blob
      item.userName = userName;
      return item;
    });
    const formData = new FormData();
    files.map((item) => { formData.append('files', item); })
    formData.append('roomId', roomId);
    formData.append('role', role);
    formData.append('recordInfo', JSON.stringify(items));
    formData.append('userId', userId);
    return formData;
  }
  
  getFileName(name, fileExtension) {
    return name +'.'+ fileExtension;
  }

}